export default __webpack_public_path__ + "static/mobile-nav-waves-3e8e6bb2cdcbb4e382d16790e099ce7f.svg";